import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { DatePipe } from '@angular/common'
import { Component, computed, effect, inject } from '@angular/core'
import { FormsModule, NgForm } from '@angular/forms'
import { PopoverComponent, UserPreviewComponent } from 'src/app/components'
import { COLORS } from 'src/app/config'
import { ITask, ITaskLabel, ITaskUpdate, IUser } from 'src/app/schemas'
import { TasksService, UsersService } from 'src/app/services'
import { formatDateTimeTz } from 'src/utils'

@Component({
  selector: 'app-task',
  imports: [FormsModule, DatePipe, UserPreviewComponent, PopoverComponent],
  templateUrl: './task.component.html',
  styleUrl: './task.component.scss',
})
export class TaskComponent {
  taskId = inject<number>(DIALOG_DATA)
  task = computed(() => this.tasksService.getTaskById(this.taskId)!)
  dialogRef =
    inject<DialogRef<{ action: 'update' | 'delete'; task: ITask }>>(DialogRef)
  private tasksService = inject(TasksService)
  private usersService = inject(UsersService)

  labels = this.tasksService.labels
  users = this.usersService.users

  availableColors = Object.keys(COLORS)

  labelsPopEnabled = false
  isAddingLabel = false
  isAssigningUser = false

  editingLabel: ITaskLabel | null = null

  constructor() {
    effect(() => {
      console.log('task updated:', this.task())
    })
  }

  hasLabel(labelId: number) {
    // console.log(this.task)
    return this.task().labels.some((l) => l.id === labelId)
  }

  handleLabelSelectChange(label: ITaskLabel, event: Event) {
    const checked = (<HTMLInputElement>event.target).checked
    if (checked) {
      this.tasksService.updateTask(this.task().id, {
        labels: [...this.task().labels, label],
      })
    } else {
      this.tasksService.updateTask(this.task().id, {
        labels: this.task().labels.filter((l) => l.id !== label.id),
      })
      // this.task().labels.splice(
      //   this.task().labels.findIndex((l) => l.id === label.id),
      //   1,
      // )
    }
  }

  setDate(field: 'due_date' | 'start_date', value: string) {
    this.onUpdateTask({ [field]: formatDateTimeTz(value) })
  }

  toggleLabelsPopover() {
    this.labelsPopEnabled = !this.labelsPopEnabled
  }
  disableLabelsPopover() {
    this.labelsPopEnabled = false
  }

  setIsAddingLabel(value: boolean) {
    this.isAddingLabel = value
  }

  onCreateLabel(formData: NgForm) {
    const { color, name } = formData.form.value
    this.tasksService.createLabel({ name, color })

    this.isAddingLabel = false
  }

  onUpdateLabel(formData: NgForm) {
    const { color, name } = formData.form.value
    this.tasksService.updateLabel(this.editingLabel!.id, { name, color })

    this.editingLabel = null
  }

  onDeleteLabel() {
    this.tasksService.deleteLabel(this.editingLabel!.id)
    this.editingLabel = null
  }

  setEditingLabel(label: ITaskLabel | null) {
    if (this.editingLabel?.id === label?.id) {
      this.editingLabel = null
    } else {
      this.editingLabel = label
    }
  }

  setIsAssigningUser(value: boolean) {
    this.isAssigningUser = value
  }

  taskHasUser(user: IUser) {
    return this.task().user_assignments.some((a) => a.user === user.id)
  }

  onAssignmentChange(user: IUser, event: Event) {
    const checked = (<HTMLInputElement>event.target).checked
    console.log('checked:', checked)

    if (checked) {
      this.tasksService.addUserAssignment(this.task().id, user.id)
    } else {
      this.tasksService.deleteUserAssignment(this.task().id, user.id)
    }
  }

  onUpdateTask(payload: Partial<ITaskUpdate>) {
    this.tasksService.updateTaskDebounced(this.taskId, payload)
  }
}
